module.exports = __webpack_public_path__ + "static/media/savio25.30bb6a68.jpg";